/**
 * LoginCtrl controller
 */

/**
 * LoginCtrl controller
 *
 * @class LoginCtrl
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc controller
 * @name mwApp/auth.controller:LoginCtrl
 */
/* @ngInject */
export default function LoginCtrl ($rootScope, $q, $state, $transition$, $location, $scope, authSvc, notifySvc, alertSvc) {
  var vm = this

  const { go } = $transition$ ? $transition$.params() : {}

  /**
   * User object
   *
   * @memberof mwApp/auth.controller:LoginCtrl
   * @type {Object}
   */
  vm.user = {
    username: null,
    password: null
  }

  /**
   * Flag, indicating that this is modal window
   *
   * @memberof mwApp/auth.controller:LoginCtrl
   * @type {Boolean}
   */
  vm.isModal = !!$scope.modalInstance

  /**
   * Perform login
   *
   * @memberof mwApp/auth.controller:LoginCtrl
   */
  vm.doLogin = function () { // should contain 'username' and 'password' fields
    const message = (code) =>
      code >= 500 ? 'Something went wrong. Please try again later.' : code === 403 ? 'User is disabled' :         // eslint-disable-line
                                       'Invalid email or password'  // eslint-disable-line
    const loginPromise = vm.hasKeycloak() ? authSvc.doKeycloakLogin() : authSvc.doLogin(vm.user)
    return loginPromise
      .then(
        () => {
          notifySvc.add('Logged in')
          if ($scope.modalInstance) {
            $scope.modalInstance.close()
          } else {
            if (go) {
              $location.url(go)
            } else {
              $state.go('app.dashboard')
            }
          }
        }
      )
      .then(() => { $rootScope.sendSessionData() })
      .catch(
        response => {
          alertSvc.alert(message(response.status), 'danger')
          if ($scope.modalInstance) {
            $scope.modalInstance.dismiss('cancel')
          } else {
            $state.go('login')
          }
        }
      )
  }

  /**
   * Perform logout
   *
   * @memberof mwApp/auth.controller:LoginCtrl
   */
  vm.doLogout = function () {
    authSvc.doLogout()
      .finally(
        () => {
          notifySvc.clear()
          if ($scope.modalInstance) {
            $scope.modalInstance.dismiss('cancel')
          }
        }
      )
  }

  vm.loadImage = function (imgName, imgRes) {
    return require('../../img/' + window.ENV.APP_PROVIDER + '/' + window.ENV.APP_PROVIDER + imgName + (!window.matchMedia('(prefers-color-scheme: dark)').matches ? '_dark' : '') + '.' + imgRes)
  }
  vm.hasKeycloak = function () {
    return authSvc.hasKeycloak()
  }

  // init timezone request
  vm.initTimezoneRequest = function () {
    authSvc.timezone()
      .then(function () {
        return vm.hasKeycloak()
          ? $q.resolve(true)
          : authSvc.getCredentials() // try to get credentials from Credentials API
            .then((user) => (vm.user = user)) // and login with them
      }).then(vm.doLogin)
      .catch((err) => console.warn(err))
  }
  if (vm.hasKeycloak()) {
    authSvc.keycloakInitEventSubscribe(go, false)
    $rootScope.$on('event:keycloakInited', function () {
      vm.initTimezoneRequest()
    })
  } else {
    vm.initTimezoneRequest()
  }
}
